import { AccountActions, AccountState, AccountsState } from './account.types';

const initialState = {
  accountState: { status: 'idle', data: null, error: '', httpStatus: 0 } as AccountState,
  updateAccountState: { status: 'idle', error: '' } as BaseState,
  accountsState: { status: 'idle', data: [], error: '' } as AccountsState
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const metadataReducer = (state = initialState, action: AccountActions): typeof initialState => {
  switch (action.type) {
    case 'GET_ACCOUNT_REQUEST':
      return {
        ...state,
        accountState: {
          ...state.accountState,
          error: '',
          status: 'pending'
        }
      };

    case 'GET_ACCOUNT_SUCCESS':
      return {
        ...state,
        accountState: {
          data: action.payload,
          error: '',
          status: 'resolved'
        }
      };

    case 'GET_ACCOUNT_FAILURE':
      return {
        ...state,
        accountState: {
          ...state.accountState,
          error: action.payload.error,
          httpStatus: action.payload.status,
          status: 'rejected'
        }
      };

    case 'UPDATE_ACCOUNT_REQUEST':
      return {
        ...state,
        updateAccountState: {
          status: 'pending',
          error: ''
        }
      };

    case 'UPDATE_ACCOUNT_SUCCESS':
      return {
        ...state,
        accountState: {
          ...state.accountState,
          data: action.payload
        },
        updateAccountState: {
          ...state.updateAccountState,
          status: 'resolved'
        }
      };

    case 'UPDATE_ACCOUNT_FAILURE':
      return {
        ...state,
        updateAccountState: {
          status: 'rejected',
          error: action.payload
        }
      };

    case 'GET_ACCOUNTS_REQUEST':
      return {
        ...state,
        accountsState: {
          ...state.accountsState,
          status: 'pending',
          error: ''
        }
      };

    case 'GET_ACCOUNTS_SUCCESS':
      return {
        ...state,
        accountsState: {
          ...state.accountsState,
          status: 'resolved',
          data: action.payload
        }
      };

    case 'GET_ACCOUNTS_FAILURE':
      return {
        ...state,
        accountsState: {
          ...state.accountsState,
          status: 'rejected',
          error: action.payload
        }
      };

    case 'CREATE_ACCOUNT_API_SUCCESS':
      return {
        ...state,
        accountState: {
          ...state.accountState,
          data: {
            ...state.accountState.data,
            api_access_key: action.payload
          }
        }
      };

    default:
      return state;
  }
};

export default metadataReducer;
